import type { Airspace } from '@/shared/types'

function rectAround(lat: number, lon: number, radius: number): [number, number][] {
  return [
    [lon - radius, lat - radius],
    [lon + radius, lat - radius],
    [lon + radius, lat + radius],
    [lon - radius, lat + radius],
    [lon - radius, lat - radius],
  ]
}

export const AIRSPACES: Airspace[] = [
  // North - training
  { id: 'as-1', code: 'KV-N01', name: 'Không vực Huấn luyện Bắc 01', type: 'training', polygon: rectAround(21.5, 105.5, 0.4), altitudeMin: 1000, altitudeMax: 6000, status: 'active', ownerUnitId: 'sd-1' },
  { id: 'as-2', code: 'KV-N02', name: 'Không vực Huấn luyện Bắc 02', type: 'training', polygon: rectAround(21.0, 106.5, 0.35), altitudeMin: 600, altitudeMax: 4500, status: 'active', ownerUnitId: 'sd-1' },
  { id: 'as-3', code: 'KV-N03', name: 'Không vực Tác chiến Bắc 03', type: 'tactical', polygon: rectAround(20.5, 106.0, 0.5), altitudeMin: 0, altitudeMax: 12000, status: 'reserved', ownerUnitId: 'sd-1' },

  // Central
  { id: 'as-4', code: 'KV-C01', name: 'Không vực Huấn luyện Trung 01', type: 'training', polygon: rectAround(16.0, 108.0, 0.4), altitudeMin: 800, altitudeMax: 5500, status: 'active', ownerUnitId: 'sd-2' },
  { id: 'as-5', code: 'KV-C02', name: 'Không vực Tác chiến Trung 02', type: 'tactical', polygon: rectAround(13.9, 108.8, 0.45), altitudeMin: 0, altitudeMax: 11000, status: 'active', ownerUnitId: 'sd-2' },
  { id: 'as-6', code: 'KV-C03', name: 'Không vực Tuần tra biển Trung 03', type: 'tactical', polygon: rectAround(15.5, 109.5, 0.6), altitudeMin: 200, altitudeMax: 8000, status: 'active', ownerUnitId: 'sd-2' },

  // South
  { id: 'as-7', code: 'KV-S01', name: 'Không vực Huấn luyện Nam 01', type: 'training', polygon: rectAround(11.0, 107.5, 0.4), altitudeMin: 700, altitudeMax: 5000, status: 'active', ownerUnitId: 'sd-3' },
  { id: 'as-8', code: 'KV-S02', name: 'Không vực Tác chiến Nam 02', type: 'tactical', polygon: rectAround(10.5, 106.5, 0.5), altitudeMin: 0, altitudeMax: 10000, status: 'active', ownerUnitId: 'sd-3' },
  { id: 'as-9', code: 'KV-S03', name: 'Không vực Bay chuyển sân Nam 03', type: 'corridor', polygon: rectAround(9.5, 105.5, 0.4), altitudeMin: 1500, altitudeMax: 7500, status: 'active', ownerUnitId: 'sd-3' },

  // Restricted
  { id: 'as-10', code: 'KV-R01', name: 'Khu vực cấm bay 01', type: 'restricted', polygon: rectAround(21.0, 105.85, 0.15), altitudeMin: 0, altitudeMax: 15000, status: 'active', ownerUnitId: 'qc-pkkq' },
  { id: 'as-11', code: 'KV-R02', name: 'Khu vực cấm bay 02', type: 'restricted', polygon: rectAround(10.78, 106.7, 0.12), altitudeMin: 0, altitudeMax: 15000, status: 'active', ownerUnitId: 'qc-pkkq' },

  // Corridor
  { id: 'as-12', code: 'KV-CR1', name: 'Hành lang bay Bắc–Trung', type: 'corridor', polygon: [[105.5, 19.0], [106.5, 19.0], [108.5, 16.5], [107.5, 16.5], [105.5, 19.0]], altitudeMin: 3000, altitudeMax: 11000, status: 'active', ownerUnitId: 'qc-pkkq' },
  { id: 'as-13', code: 'KV-CR2', name: 'Hành lang bay Trung–Nam', type: 'corridor', polygon: [[108.0, 16.0], [109.0, 16.0], [107.0, 11.0], [106.0, 11.0], [108.0, 16.0]], altitudeMin: 3000, altitudeMax: 11000, status: 'active', ownerUnitId: 'qc-pkkq' },
]

export const AIRSPACES_BY_ID: Record<string, Airspace> = Object.fromEntries(
  AIRSPACES.map((a) => [a.id, a]),
)

export const AIRSPACE_TYPE_COLORS: Record<Airspace['type'], string> = {
  training: '#10b981',
  tactical: '#1e6091',
  restricted: '#ef4444',
  corridor: '#f59e0b',
  reserved: '#8b5cf6',
}
